import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const meetingRoomBookingService = {
    getAll,
    showAllBooking,
    store,
    destroy
};

const MODULE = {
    MEETING_ROOM_BOOKING: 'portal/meeting-room-bookings',
};

const API_URL = API.BASE_URL_APP + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            meeting_room_uuid: filter?.meetingRoomUuid,
            meeting_date_start: filter?.meetingDateStart,
            meeting_date_end: filter?.meetingDateEnd,
            is_show_all: filter?.isShowAll,
            is_active: filter?.isActive,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    return apiHelper(API_URL).get(`/${MODULE.MEETING_ROOM_BOOKING}`, request);
}

export function showAllBooking (filter) {
    const request = {
        params: {
            meeting_room_uuids: (filter?.meetingRoomUuids ?? []).map(item => item),
            meeting_date_start: filter?.meetingDateStart,
        },
    };

    return apiHelper(API_URL).get(`/${MODULE.MEETING_ROOM_BOOKING}/show-all-bookings`, request);
}

export function store (data) {
    const request = {
        agenda: data.agenda,
        detail: data.detail,
        start: data.start,  // eg. 2026-10-28 09:00
        end: data.end,
        meeting_room_uuids: (data.meetingRoomUuids ?? []).map(item => item)
    };

return apiHelper(API_URL).post(`/${MODULE.MEETING_ROOM_BOOKING}`, request);
}

export function destroy (data) {
    return apiHelper(API_URL).delete(`/${MODULE.MEETING_ROOM_BOOKING}/${data.uuid}`);
}